<alaris-dialog [closeAction]="close.bind(this)"
			   [confirmAction]="confirm.bind(this)"
			   size="md">
	<h6 slot="header">
		{{ 'settings.title' | translate }}
	</h6>
	<div slot="content">
		<p>{{ 'settings.import_dialog' | translate }}</p>
	</div>
</alaris-dialog>